import { NotificationStatus, type NotificationType } from "@fitness-app/data-models/entities/Notification";

import { type StoreDependencies } from "../../../index";

/**
 * Badges render `99+` past 99, so the count stops at 100. An exact count made PostgREST walk every
 * unread row of the owner and run the dish-rating RESTRICTIVE policy on each - 1.1 s for the
 * Hollywood owner, up to 6 s p99 in Sentry (TRE-2326). The first 100 rows by `createdAt` come
 * straight off `notification_ownerId_status_createdAt_idx` in tens of milliseconds.
 */
export const UNREAD_NOTIFICATIONS_CAP = 100;

export const countUnreadNotifications = async (
  db: StoreDependencies["db"],
  ownerId: string,
  types?: NotificationType[],
): Promise<number | null> => {
  let query = db.from("notification").select("id").eq("ownerId", ownerId).eq("status", NotificationStatus.UNREAD);

  if (types?.length) {
    query = query.in("type", types);
  }

  const { data, error } = await query.order("createdAt", { ascending: false }).limit(UNREAD_NOTIFICATIONS_CAP);

  // A failed count leaves the badge as it was rather than zeroing it.
  return error ? null : data.length;
};
